import isFunction from 'lodash/isFunction';

import { getGa } from 'core/googleAnalytics';

type EventCategory = 'PURCHASES_V2';

type EventAction = 'GET_RECEIPTS' | 'OPEN_PURCHASE_DETAILS';

type ReportPayload = {
  hitType: 'event';
  eventCategory: EventCategory;
  eventAction: EventAction;
  eventLabel?: string;
  eventValue?: number;
};

const report = (payload: ReportPayload) => {
  const ga = getGa();

  if (!isFunction(ga)) {
    return;
  }

  ga('send', payload);
};

export const reportGetReceipts = () => {
  report({
    hitType: 'event',
    eventCategory: 'PURCHASES_V2',
    eventAction: 'GET_RECEIPTS',
  });
};

export const reportPurchaseDetailsOpen = () => {
  report({
    hitType: 'event',
    eventCategory: 'PURCHASES_V2',
    eventAction: 'OPEN_PURCHASE_DETAILS',
  });
};
